import {useAuth} from '@/composables/useAuth';
import {useStorage} from '@/composables/useStorage';
import {logger, LogCategory} from '@/services/logger';
import {Ref} from 'vue';
import {DOCUMENT_STATUS} from "@/types/document";

export class ExcelTemplateUploadService {
    async uploadTemplateFile(
        templatesFileName: Ref<string, string>,
        templatesSelectedFile: Ref<{
            readonly lastModified: number;
            readonly name: string;
            readonly webkitRelativePath: string;
            readonly size: number;
            readonly type: string;
            arrayBuffer: () => Promise<ArrayBuffer>;
            bytes: () => Promise<Uint8Array>;
            slice: (start?: number, end?: number, contentType?: string) => Blob;
            stream: () => ReadableStream<Uint8Array>;
            text: () => Promise<string>;
        } | null, File | null>,
        forecastId?: string,
        userData?: any) {

        const {uploadFile: uploadStorageFile} = useStorage();
        const {checkAndRefreshAuth} = useAuth();

        const TEMPLATES_BUCKET = 'Templates';

        if (!templatesSelectedFile.value) return;

        // Check and refresh authentication if needed
        const isAuthenticated = await checkAndRefreshAuth();
        if (!isAuthenticated) {
            throw new Error('Authentication required');
        }

        // Generate a unique file path
        const timestamp = new Date().getTime();
        const finalFileName = templatesFileName.value || templatesSelectedFile.value.name;
        const filePath = `${timestamp}-${finalFileName}`;

        // Upload the file
        logger.info('Uploading file to Templates', LogCategory.STORAGE, {
            bucket: TEMPLATES_BUCKET,
            fileName: filePath,
            originalName: templatesSelectedFile.value.name,
            size: templatesSelectedFile.value.size
        });

        const data = await uploadStorageFile(TEMPLATES_BUCKET, filePath, templatesSelectedFile.value, {
            customFileName: finalFileName,
            userId: userData?.id || '',
            documentStatus: DOCUMENT_STATUS.UPLOADED_CHECKING,
            createDocumentEntry: true,
            forecastId: forecastId || '',
            reportType: userData?.report_type as string || ''
        });

        logger.info('File uploaded successfully to Templates', LogCategory.STORAGE, {
            bucket: TEMPLATES_BUCKET,
            path: data.path || filePath
        });

        return data;
    }
}

